import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";

export const getStudentCoursesPanel = async (params) => {
  const res = await axios.middleware("/Social.asmx/PainelCursos", {
    params,
  });
  return res[0].data;
};

export const useStudentCoursesPanel = ({ config, studentId } = {}) => {
  return useQuery({
    ...config,
    placeholderData: [],
    queryFn: () => getStudentCoursesPanel({ alunoid: studentId }),
    queryKey: ["socialMediaPanel", { studentId, type: "courses" }],
  });
};
